class DefinitionList {
  constructor(container) {
    this.container = container;
    jQuery(document).ready(() => {
      this._findServerErrors();
      jQuery(container).on("blur", ".field-input", (event) => {
        this._checkInputValidity(event.target);
      });
    });
  }

  _findServerErrors() {
    const getErrors = jQuery(this.container).find(".field_with_errors .field-input");
    for (const errorElement of getErrors) {
      const $input = jQuery(errorElement).children(".field-input");
      $input.data("wasInvalid", true);

      // Let everyone know about the validity
      jQuery(this.container).trigger("input:validation", [errorElement, false, false]);
    }
  }

  _checkInputValidity(input) {
    const valid = input.checkValidity();
    const wasInvalid = jQuery(input).data("wasInvalid") === true;
    jQuery(input).data("wasInvalid", !valid);
    jQuery(input).addClass("user-interacted");

    // Let everyone know about the validity
    jQuery(this.container).trigger("input:validation", [input, valid, wasInvalid]);
  }
}

window.DefinitionList = DefinitionList;
